import {useEffect} from 'react';

const useOutsideClick = (ref: React.RefObject<HTMLElement>, callback: () => void) => {
  const handleClick = (e: MouseEvent) => {
    if (ref?.current && !ref?.current?.contains(e.target as Node)) {
      e.stopPropagation();
      console.log('outside click', ref);
      callback();
    }
  };

  /* For wrapping in why event listener was wrapper in timeout, cause
     earlier it was working in React 17 but not in React 18, so to make it work in React 18, this was done
     due to useEffect changes in React 18

     For More Info
     https://stackoverflow.com/questions/72315874/react-click-outside-event-happens-right-after-click-to-open-preventing-the-mod
  */
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      document.addEventListener('click', handleClick, false);
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener('click', handleClick, false);
    };
  }, [ref, callback]);
};

export default useOutsideClick;
